import NavAdmin from '../nav-admin/nav-admin';

const HeaderDashboard = () => (
    <div className="HeaderDashboard">
        <section>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
                <div className="container w-max2">
                    {/*Main Header*/}
                    <div className="admin-title">
                        <i className="bi bi-grid-3x3-gap" title="Dashboard Head Title"></i> <span >DASHBOARD</span>
                    </div>
                    {/*Admin Menus*/}
                    <NavAdmin />
                </div>
            </nav>
        </section>
    </div>
);

export default HeaderDashboard;
